import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ExtendedBaseTab } from '@common/classes/extended-base-tab';
import { TranslateService } from '@ngx-translate/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { ModalService } from '@services/modal.service';
import { CustomExtendedTabService } from 'app/singleton-services/custom-extended-tab.service';

@Component({
    selector: 'app-pcs-approval-tab-notifications',
    templateUrl: './pcs-approval-tab-notifications.component.html',
    styleUrls: ['./pcs-approval-tab-notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PcsApprovalTabNotificationsComponent extends ExtendedBaseTab implements OnInit {
    @Input()
    notifications: any[];

    skip = 0;

    pageSize = 10;

    gridView: GridDataResult;

    openedId = -1;

    constructor(
        customExtendedTabService: CustomExtendedTabService,
        protected dialogService: ModalService,
        protected translateService: TranslateService
    ) {
        super(customExtendedTabService);
    }

    ngOnInit(): void {
        this.loadItems();
    }

    public pageChange({ skip, take }: PageChangeEvent): void {
        this.skip = skip;
        this.pageSize = take;
        this.loadItems();
    }

    loadItems(): void {
        this.gridView = {
            data: this.notifications.slice(this.skip, this.skip + this.pageSize),
            total: this.notifications.length
        };
    }
}
